/* Design (BUILD-06 design canvas, with the MEDIA-01/02 editor entry points and the OFFICE-02 deck
   hand-off). Screen: a vector editor over api/src/modules/build (design docs, op log, brand kits,
   export manifests) and api/src/modules/media (image jobs and assets). */
import { lazy } from 'react';
import { PenTool } from 'lucide-react';
import { defineFeature } from '../../app/feature';

export default defineFeature({
  id: 'design',
  title: 'Design',
  icon: PenTool,
  group: 'Apps',
  route: '/design',
  order: 80,
  screen: lazy(() => import('./Screen.tsx')),
  capabilities: ['BUILD-06', 'MEDIA-01', 'MEDIA-02', 'OFFICE-02'],
  commands: [
    { id: 'open', title: 'Open a design', to: '/design?open=1', keywords: ['canvas', 'artboard', 'figma', 'poster'] },
    { id: 'new-poster', title: 'New poster design', to: '/design?new=poster', keywords: ['template', 'flyer', 'canvas'] },
    { id: 'new-social', title: 'New social post design', to: '/design?new=social', keywords: ['template', 'instagram', 'square'] },
    { id: 'new-slide', title: 'New slide design', to: '/design?new=slide', keywords: ['template', '16:9'] },
    { id: 'keys', title: 'Design keyboard shortcuts', to: '/design?keys=1', keywords: ['shortcuts', 'keys'] },
  ],
});
